import { render, staticRenderFns } from "./TesterProfile.vue?vue&type=template&id=f58c6156&scoped=true"
import script from "./TesterProfile.vue?vue&type=script&lang=js"
export * from "./TesterProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58c6156",
  null
  
)

export default component.exports